import mask from 'slim-mask-js'

export default str => {
  if (!str) {
    return '-'
  }
  if (str.length === 11) {
    return mask(str, '+## (##) # ####-####')
  }
  return mask(str, '+## (##) ####-####')
}
